export type Status = 'idle' | 'pending' | 'resolved' | 'rejected';
export enum STATUS {
    IDLE = 'idle',
    PENDING = 'pending',
    RESOLVED = 'resolved',
    REJECTED = 'rejected',
}
